import { Mail, ExternalLink } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = ({ products }) => {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer-section" className="bg-[#020617] text-slate-400">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed">
            Operational software for warehouses, workforces, retail counters and beyond — built
            and supported by Smart-In.
          </p>
        </div>

        <div>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-white">
            Products
          </p>
          <ul className="mt-5 space-y-3">
            {products.map((p) => (
              <li key={p.slug}>
                <a
                  data-testid={`footer-product-link-${p.slug}`}
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm transition-colors hover:text-white"
                >
                  {p.title}
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-white">
            Contact
          </p>
          <ul className="mt-5 space-y-3">
            <li>
              <a
                data-testid="footer-email-link"
                href="mailto:info@smrtin.net"
                className="inline-flex items-center gap-2 text-sm transition-colors hover:text-white"
              >
                <Mail className="h-4 w-4 text-[#F59E0B]" />
                info@smrtin.net
              </a>
            </li>
            <li>
              <a
                data-testid="footer-website-link"
                href="https://retail.smrtin.net"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-sm transition-colors hover:text-white"
              >
                retail.smrtin.net
                <ExternalLink className="h-3 w-3" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <p className="text-center text-xs">
          © {year} Smart-In · Smrtin. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
